/*
  hp-stoq-preorder
  ----------------
  Underlines the ship date inside the STOQ preorder note.

  The app renders its whole sentence as ONE flat text node —
  "This preorder item is expected to ship by October 31st." — so there is nothing
  for CSS to single out. The stylesheet sets the whole sentence in Body Bold;
  this finds the DATE within it and wraps it so it can take the underline:

    <span class="hp-stoq-detail__date">October 31st</span>

  IT MATCHES A DATE, NOT A PUNCTUATION MARK. An earlier version split the string
  at its colon, which worked only while the merchant's copy happened to contain
  one — the copy was then reworded to read as a sentence and the split silently
  stopped firing, with no error and no visible clue beyond the emphasis being
  gone. A date pattern is a property of the thing being marked rather than of one
  phrasing, so rewording the sentence around it cannot break it.

  IT NEVER REMOVES OR REWRITES COPY. The pieces are the original string, so a
  merchant editing the wording in the STOQ admin cannot be contradicted by
  anything here. A sentence with no recognisable date is left exactly as the app
  wrote it and renders as plain Body Bold — which is also what happens if this
  script fails to load, and is why the stylesheet styles that case too. Same
  invariant as hp-image-fade.js: a script that does not run must not be able to
  cost the shopper content.

  IT HAS TO BE AN OBSERVER. The app injects the note well after DOMContentLoaded
  (its script fetches config first) and re-renders it on variant change, so a
  one-shot pass on load finds nothing. Idempotency is the class check, which
  keeps the observer cheap and stops it reacting to its own writes.
*/
(function () {
  'use strict';

  var TEXT = '.preorder-detail-text';
  var DONE = 'hp-stoq-detail__date';

  var MONTH =
    '(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?' +
    '|Jul(?:y)?|Aug(?:ust)?|Sep(?:t)?(?:ember)?|Oct(?:ober)?|Nov(?:ember)?' +
    '|Dec(?:ember)?)';
  var ORD = '(?:st|nd|rd|th)';

  // The four shapes STOQ can emit, in the order they are worth trying. A bare
  // month name cannot match on its own — every branch requires a day number —
  // so ordinary prose ("may be delayed") is never mistaken for a date.
  var DATE = new RegExp(
    '\\b(?:' +
      MONTH + '\\.?\\s+\\d{1,2}' + ORD + '?(?:,?\\s+\\d{4})?' +
      '|\\d{1,2}' + ORD + '?\\s+' + MONTH + '\\.?(?:,?\\s+\\d{4})?' +
      '|\\d{4}-\\d{1,2}-\\d{1,2}' +
      '|\\d{1,2}[/-]\\d{1,2}(?:[/-]\\d{2,4})?' +
    ')',
    'i'
  );

  function enhance(el) {
    if (el.querySelector('.' + DONE)) return; // already marked

    var raw = el.textContent;
    var hit = DATE.exec(raw);
    if (!hit) return;

    var before = raw.slice(0, hit.index);
    var after = raw.slice(hit.index + hit[0].length);

    var dateEl = document.createElement('span');
    dateEl.className = DONE;
    dateEl.textContent = hit[0];

    el.textContent = '';
    if (before) el.appendChild(document.createTextNode(before));
    el.appendChild(dateEl);
    if (after) el.appendChild(document.createTextNode(after));
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;
    if (root.matches && root.matches(TEXT)) enhance(root);
    var found = root.querySelectorAll ? root.querySelectorAll(TEXT) : [];
    for (var i = 0; i < found.length; i++) enhance(found[i]);
  }

  scan(document.body);

  new MutationObserver(function (records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) scan(added[j]);
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
